export default "__VITE_ASSET__BSSRT5vn__"